<template>
  <div>
    <b-modal
      id="admin-create-modal"
      title="Create new Admin"
      ok-title="Save"
      no-close-on-backdrop
      @ok="handleOK"
      @close="closeHandler"
    >
      <b-form
        novalidate
      >
        <validation-observer ref="formRef">
          <validation-provider
            #default="{ errors }"
            name="Email"
            rules="required"
          >
            <b-form-group
              label="Email"
              label-for="admin-email"
            >
              <b-form-input
                id="admin-email"
                v-model="adminData.email"
                placeholder="Email"
              />
              <span class="text-danger"> {{ errors[0] }} </span>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Status"
            label-for="edit-status"
          >
            <v-select
              v-model="adminData.role"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="roles.map(role => role.name)"
              :clearable="false"
            />
          </b-form-group>
          <b-form-group
            label="Country"
            label-for="edit-country"
          >
            <v-select
              v-model="adminData.countries"
              :options="countries"
              :reduce="v => v.code"
              multiple
              :clearable="false"
            />
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import store from '@/store'
import roleStoreModule from '@/views/users/roles/roleStoreModule'
import useRolesList from '@/views/users/roles/userRolesList'
import countries from './countries'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
  },
  setup(props, { emit, root }) {
    // Register Role Module
    const ROLE_APP_STORE_MODULE_NAME = 'roles'

    // Register module
    if (!store.hasModule(ROLE_APP_STORE_MODULE_NAME)) {
      store.registerModule(ROLE_APP_STORE_MODULE_NAME, roleStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ROLE_APP_STORE_MODULE_NAME)) store.unregisterModule(ROLE_APP_STORE_MODULE_NAME)
    })
    const adminData = ref({
      email: null,
      role: null,
      countries: [],
    })
    const showLoading = ref(false)

    const {
      roles,
      fetchRoles,
    } = useRolesList()

    fetchRoles()

    const onSave = async () => {
      showLoading.value = true
      await store.dispatch('admins/putAdmin', {
        ...adminData.value,
        country: adminData.value.countries[0],
      })
      emit('refetch-data')
      root.$bvModal.hide('admin-create-modal')
      showLoading.value = false
    }

    const handleOK = async bvModalEvt => {
      bvModalEvt.preventDefault()
      await onSave()
    }
    const closeHandler = () => {
      adminData.value.email = null
      adminData.value.role = null
      adminData.value.countries = []
    }

    return {
      roles,
      adminData,
      showLoading,
      onSave,
      countries,
      handleOK,
      required,
      closeHandler,
    }
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
